import React from 'react';
export function HeroSection() {
  return <div className="bg-[#002d4d] py-12 px-4" data-id="element-1646">
      <div className="max-w-4xl mx-auto text-center" data-id="element-1647">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white tracking-tight" data-id="element-1648">
          Contact Peak Machine Sales (Peak EDM Inc.)
        </h1>
      </div>
    </div>;
}